var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuscriptionPaymentsWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.0707,
    height: 49.0707,
    rx: 6.92763,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2244 13.5981C18.4841 13.5981 15.8053 14.4107 13.5268 15.9331C11.2483 17.4555 9.47248 19.6194 8.42381 22.1512C7.37514 24.6829 7.10076 27.4687 7.63537 30.1564C8.16997 32.844 9.48956 35.3128 11.4273 37.2505C13.3649 39.1882 15.8337 40.5078 18.5214 41.0424C21.209 41.577 23.9949 41.3026 26.5266 40.2539C29.0583 39.2053 31.2222 37.4294 32.7446 35.1509C34.2671 32.8724 35.0797 30.1936 35.0797 27.4533L21.2244 27.4533L21.2244 13.5981Z",
    fill: "#426DD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7023 23.439C41.7023 21.3802 41.2967 19.3416 40.5089 17.4396C39.721 15.5375 38.5662 13.8093 37.1105 12.3535C35.6547 10.8977 33.9265 9.74294 32.0244 8.95508C30.1223 8.16722 28.0837 7.76172 26.025 7.76172L26.025 23.439H41.7023Z",
    fill: "#426DD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuscriptionPaymentsWeb);
export default __webpack_public_path__ + "static/media/SuscriptionPayments_web.c1f697d3440abcc82d5a0cb6f6bc498b.svg";
export { ForwardRef as ReactComponent };